// extracted by mini-css-extract-plugin
var _1 = "CalendarGridDayLoadChip-moduleCalendarGridDayLoadChip__zfpuz CalendarGridChip-moduleCalendarGridChip__XUmFk";
export { _1 as "CalendarGridDayLoadChip" }
